import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { ThemeService } from 'src/app/services/theme.service';
import { MenuService } from 'src/app/routes/menu/menu.service';
import { DASHBOARD_ENABLED } from 'src/app/common/constants/dashboard-visibility';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.sass']
})
export class SideMenuComponent implements OnInit {
  @Input() storeTransferCount = 0;
  @Output() transferModalRequested = new EventEmitter<void>();
  @Output() closeRequested = new EventEmitter<void>();

  sideMenuItems: any[] = [];

  /** The dashboard entry is hidden while the route redirects to /home. */
  dashboardEnabled = DASHBOARD_ENABLED;

  constructor(
    private menuService: MenuService,
    private authService: AuthService,
    private themeService: ThemeService
  ) {}

  async ngOnInit() {
    this.sideMenuItems = await this.menuService.fetchSideMenuItems();
  }

  toggleMenu(index: number): void {
    this.sideMenuItems.forEach((section, i) => {
      section.items.forEach((menu: { type: string; expanded: boolean; }, j: any) => {
        if (i !== index && menu.type === 'collapsible') menu.expanded = false;
      });
    });

    this.sideMenuItems[index].items.forEach((menu: any) => {
      if (menu.type === 'collapsible') {
        menu.expanded = !menu.expanded;
      }
    });
  }

  handleAction(actionName: string): void {
    const actions: { [key: string]: () => void } = {
      logout: () => this.logout(),
      onThemeSwitched: () => this.onThemeSwitched(),
      openTransferModal: () => this.onTransferModal(),
    };

    if (actions[actionName]) {
      actions[actionName]();
    } else {
      console.error(`Action "${actionName}" is not defined.`);
    }
  }

  onTransferModal(): void {
    this.transferModalRequested.emit();
  }

  onNavigate(): void {
    this.closeRequested.emit();
  }

  logout(redirectToLogin: boolean = true): void {
    this.authService.logout(redirectToLogin);
    window.location.reload();
  }

  onThemeSwitched(): void {
    this.themeService.toggle();
  }
}
